import { useNavigate } from "react-router-dom";
import { ListFetch } from "../../lib/typeDeclarations";
import { useListRecords } from "../../server/hooks/getData";
import { addIcon, check } from "../../assets/icons";

import Header from "../../components/layout/Header";
import { TextInput } from "../../components/inputs/TextInput";
import { Dropdown } from "../../components/inputs/Dropdown";
import { FilterBar, Page, PageBody, PageHeader } from "../../components/layout/Page";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { Loader } from "../../components/loader/Loader";
import "../../components/layout/listitem.css";
import { formatDate } from "../../lib/dateHelper";
import { useFilters } from "../../lib/setSearchParams";
import { MultiSelect } from "../../components/inputs/MultiSelect";
import { on } from "events";

export default function JobList() {
  document.title = "Munkák";
  const navigate = useNavigate();

  //States
  const { filters, setFilters } = useFilters();

  const headers = [
    "Munkaszám",
    "Kal. szám",
    "Átvéve",
    "Ügyfél",
    "Eszköz",
    "Gyári sz.",
    "Javítás",
    "Kalibrálás",
    "Státusz",
  ];
  const { data: statuses, loading: statusL }: ListFetch = useListRecords("status", [], null);
  const { data: jobs, loading }: ListFetch = useListRecords(
    "jobs",
    [JSON.stringify(filters)],
    {
      ...filters,
      orderBy: "job_number",
      order: "DESC",
    },
    60000
  );

  const jobType = [
    { id: 1, value: "Igen" },
    { id: 0, value: "Nem" },
  ];

  const navOnClick = (id: any, e: React.MouseEvent) => {
    if (e.button === 0) {
      navigate(`/jobs/${id}`);
    } else if (e.button === 1) {
      e.preventDefault();
      window.open(`/jobs/${id}`, "_blank");
    }
  };

  //Component
  return (
    <Page>
      <Header
        itemCounter={{
          page: jobs.page,
          limit: jobs.limit,
          total: jobs.total,
          setPage: setFilters,
        }}>
        <PrimaryButton btn={{ svgBefore: addIcon, text: "Létrehozás", onClick: () => navigate("new") }} />
      </Header>
      <PageHeader title="Munkák" />
      <FilterBar>
        <TextInput stateKey="job_number" placeholder="Munkaszám" state={filters} setState={setFilters} />
        <TextInput stateKey="cal_number" placeholder="Kal. szám" state={filters} setState={setFilters} />
        <TextInput stateKey="client_name" placeholder="Ügyfél" state={filters} setState={setFilters} />
        <MultiSelect
          state={filters}
          stateKey="status_id"
          setState={setFilters}
          list={statuses.data}
          listKeys={["status_name"]}
          placeholder="Státusz"
        />
        <Dropdown
          state={filters}
          stateKey="calibration"
          setState={setFilters}
          list={jobType}
          listKeys={["value"]}
          listTarget="id"
          placeholder="Kalibrálás"
        />
        <Dropdown
          state={filters}
          stateKey="repair"
          setState={setFilters}
          list={jobType}
          listKeys={["value"]}
          listTarget="id"
          placeholder="Javítás"
        />
      </FilterBar>
      {!loading && !statusL ? (
        <>
          <PageBody>
            <div className="listitem">
              <table>
                <thead>
                  <tr>
                    {headers.map((item) => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {jobs.data.length !== 0 ? (
                    jobs.data.map((item) => (
                      <tr
                        key={item.id}
                        onMouseUp={(event) => navOnClick(item.id, event)}
                        onMouseDown={(e) => e.preventDefault()}>
                        <td>{`${item.job_number_prefix ? item.job_number_prefix : ""}${item.job_number}`}</td>
                        <td>{item.cal_number ? `${item.cal_number_prefix ?? ""}${item.cal_number}` : "---"}</td>
                        <td>{formatDate(item.date)}</td>
                        <td>{item.client_name}</td>
                        <td>{item.device}</td>
                        <td>{item.serial_no}</td>
                        <td>{item.repair !== 0 && check}</td>
                        <td>{item.calibration !== 0 && check}</td>
                        <td>
                          <div
                            className="status"
                            style={{
                              backgroundColor: `${statuses?.data.find((e) => item.status_id === e.id).color}`,
                              color: "#22252a",
                            }}>
                            <span style={{ color: `${item.status_color}` }}>{item.status}</span>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={headers.length + 1} style={{ textAlign: "center" }}>
                        Nincs találat!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </PageBody>
        </>
      ) : (
        <Loader />
      )}
    </Page>
  );
}
